import { func, bool } from 'prop-types';
import React from 'react';

const TopBar = ({ topText, onClose }) => {
	return (
		<div className="status-and-close d-flex justify-content-between">
			{topText ? (
				<div>
					<span className="status red-3 round">Top</span>
				</div>
			) : (
				<div></div>
			)}

			{onClose && (
				<div className="close-icon cursor-pointer" onClick={onClose}>
					<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="Close" />
				</div>
			)}
		</div>
	);
};
TopBar.propTypes = {
	topText: bool.isRequired,
	onClose: func
};

export default TopBar;
